import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-sub-menu',
  templateUrl: './nav-sub-menu.component.html',
  styleUrls: ['./nav-sub-menu.component.scss'],
})
export class NavSubMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

  quoteClicked(){
    window.open("https://www.mypolicyjunction.com/termins.html", "_self");
  }

  healthQuoteClicked(){
    window.open("https://www.mypolicyjunction.com/healthins.html", "_self");
  }

  vehicleQuoteClicked(){
    window.open("https://www.mypolicyjunction.com/vehicleins.html", "_self");
  }

  topupQuoteClicked(){
    window.open("https://www.mypolicyjunction.com/topupins.html", "_self");
  }

}
